import { api } from "../../http";

async function GetFindAllDataItem() {
  try {
    
    const data = await api.get(`/items`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetFindAllDataItem };
